<template>
  <validation-observer v-slot="{ handleSubmit, reset }">
    <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" class="main_form stepform_1">
      <div v-if="SHOW_ERROR" class="notification-bar">
            <p class="body_small pt-0">{{$t('EMAIL_ERROR')}}</p>
      </div>
      <div :class="['w-layout-grid grid-8', SHOW_ERROR ? 'error' : '']">
        <div id="w-node-_5ec2a138-20c9-6013-c0f0-de0f04da68f8-82aff37d" class="form_field w-clearfix">
         <validation-provider class="" name="FULLFILL_EMAIL" rules="required|email" v-slot="{ errors, classes }">
            <h1 class="field_label">{{$t('FULLFILL_EMAIL')}}</h1>
            <input v-model="data.EMAIL" type="text" name="FULLFILL_EMAIL" :class="['text_field_input text-field w-input', SHOW_ERROR ? 'error' : '']" maxlength="256" placeholder="yourname@xxx.com" autofocus />
            <span :class="classes">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div id="w-node-_6a2697d8-e06d-930f-4747-295fb4719491-82aff37d" class="form_field w-clearfix">
         <validation-provider class="" name="VALIDATE_EMAIL" rules="required|email" v-slot="{ errors, classes }">
            <h1 class="field_label">{{$t('VALIDATE_EMAIL')}}</h1>
            <input v-model="EMAIL_CONFIRM" type="text" name="VALIDATE_EMAIL" :class="['text_field_input text-field w-input', SHOW_ERROR ? 'error' : '']" maxlength="256" placeholder="yourname@xxx.com" />
            <span :class="classes">{{ errors[0] }}</span>
          </validation-provider>
        </div>
        <div id="w-node-d221c781-86af-7027-d4d7-b6efb77373ff-82aff37d" class="form_field">
          <button type="submit" class="submit-button submit-button-2 main_button w-button" >{{ $t('CONTINUE') }}</button>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column w-col w-col-6"></div>
            <div class="column-12 w-col w-col-6"></div>
          </div>
        </div>
      </div>
    </form>
  </validation-observer>
</template>

<script>
export default {
  mounted() {
    this.$el.querySelector('[autofocus]').focus();
  },
  data() {
    return {
      EMAIL_CONFIRM: '',
      SHOW_ERROR: false
    };
  },
  computed: {
    isMailConfirmed() {
      return this.data.EMAIL === this.EMAIL_CONFIRM;
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    submitForm() {
      this.SHOW_ERROR = !this.isMailConfirmed;
      if (this.isMailConfirmed) {
        this.$emit('email-confirmation');
      }
    }
  },
};
</script>
